import { Snapshot } from "luxedo-data"
import { ApiClient } from "rest-api-client"
import { LuxedoRPC } from "luxedo-rpc"

export namespace SnapshotAPI {
	const apiClient = new ApiClient(import.meta.env.VITE_API_URL)
	export async function saveEditedSnapshot(
		img: Blob,
		calibrationId: number
	): Promise<Snapshot["id"]> {
		const formData = new FormData()
		formData.append("image", img, `snapshot.png`)
		formData.append("calibration_id", String(calibrationId))
		formData.append("edited", String(true))

		const headers = new Headers()
		headers.append("X-Csrftoken", LuxedoRPC.getCsrfToken())
		const res = await apiClient.postFormData("/api/snapshots", formData, {
			headers,
		})
		return res.id
	}
}
